import { render, staticRenderFns } from "./AuthFailed.vue?vue&type=template&id=86d146f8&"
import script from "./AuthFailed.vue?vue&type=script&lang=ts&"
export * from "./AuthFailed.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports